<template>
    <table class="control-table tokens-table">
        <thead class="control-table__head">
            <tr class="control-table__row">
                <th style="min-width: 30%" class="control-table__cell tokens-table__cell">
                    <div class="control-table__cell-inner">
                        <span v-t="'crm.tokens.list.name'" />
                        <TableSorting
                            v-if="sortingFields.includes('name')"
                            v-model="ordering"
                            field="name"
                        />
                    </div>
                </th>
                <th class="control-table__cell tokens-table__cell">
                    <span v-t="'crm.tokens.list.prefix'" />
                </th>
                <th style="width: 10%" class="control-table__cell">&nbsp;</th>
            </tr>
        </thead>
        <tbody v-if="tokens.length" class="control-table__body">
            <tr
                v-for="token in tokens"
                :key="token.id"
                class="control-table__row tokens-table__row"
            >
                <td class="control-table__cell tokens-table__cell">
                    {{ token.name }}
                </td>
                <td class="control-table__cell tokens-table__cell">
                    {{ token.prefix }}
                </td>
                <td class="control-table__cell tokens-table__cell tokens-table__cell--right">
                    <TokensDelete
                        v-if="token.permissions.destroy"
                        :token="token"
                        @deleted="onDeleted"
                    />
                </td>
            </tr>
        </tbody>
    </table>
</template>

<script>
import TokensDelete from '../TokensDelete/TokensDelete';
import TableSorting from '@speechki-frontend/shared/ui/TableSorting';

export default {
    name: 'TokensTable',
    components: {
        TokensDelete,
        TableSorting,
    },
    props: {
        tokens: {
            type: Array,
            default: () => [],
        },
        sortingFields: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            ordering: 'name',
        };
    },
    watch: {
        ordering() {
            this.$emit('sort', this.ordering);
        },
    },
    methods: {
        onDeleted(event) {
            this.$emit('deleted', event);
        },
    },
};
</script>

<style src="./TokensTable.scss" lang="scss"></style>
